/**
 * EU Right to Withdrawal portal
 * -----------------------------
 * Lean flow (no return/exchange/alteration/payment here):
 *   1. Customer searches by Order ID + mobile / email / postal code / name.
 *   2. We verify identity via POST /v1/api/web/withdrawal/order-items.
 *   3. EU gate: if the order is NOT an EU order -> show a "not applicable" message and stop.
 *   4. If the order is UNFULFILLED -> show the item-cancellation UI (reason optional)
 *      and submit to POST /v1/api/web/withdrawal/cancel (backend auto-accepts EU orders).
 *   5. If the order is FULFILLED -> show a message + a button that takes the customer to
 *      the returns page (/pages/returns) with their search details pre-filled
 *      (via order_no + buyer_lead_id, which return-portal.js reads from the URL).
 *
 * The withdrawal/order-items response provides: is_eu_order, is_fulfilled,
 * shipping_country_code, order (orders.id), customer (buyer_leads.id), order_no,
 * buyer_lead_id, cancel_reasons[], and cancelable[] (unfulfilled line items).
 * The client-side EU_COUNTRIES list below is only a defensive fallback if
 * is_eu_order is ever absent.
 */
(function () {
  var baseEndpointUrl = 'https://mp.mygoddiva.com';
  var RETURNS_PAGE_URL = '/pages/returns';
  // The "Where did you place the order?" dropdown is hidden on this page; we always
  // search the Goddiva marketplace. Change here (and unhide the dropdown in the liquid)
  // if marketplace selection is ever needed again.
  var MARKETPLACE_ID = 1;

  // Interim client-side EU list — used ONLY if the API response omits `is_eu_order`.
  // Mirrors the backend EU list in CustomOrderHelper.php (UK/GB/GG/JE/IM are NOT EU).
  var EU_COUNTRIES = [
    'AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'EL', 'ES', 'FI', 'FR', 'GR',
    'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'
  ];

  var selectOption = 'phone';
  var marketplacesData = [];
  var allData = null;

  $.ajaxSetup({
    headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') }
  });

  /* ----------------------------------------------------------------------
   * Marketplace list
   * -------------------------------------------------------------------- */
  var selectElement = document.getElementById('marketplaces');
  $('.search').prop('disabled', true);
  $('.spinner-border').hide();

  fetch(baseEndpointUrl + '/v1/api/marketplaces')
    .then(function (response) {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    })
    .then(function (data) {
      marketplacesData = data;
      data.forEach(function (item) {
        var option = document.createElement('option');
        option.value = item.id;
        option.text = item.name;
        option.setAttribute('data-manage-return-by', item.manage_return_by || '');
        option.setAttribute('data-customer-return-instructions', item.customer_return_instructions || '');
        selectElement.appendChild(option);
      });
      $('.search').prop('disabled', false);
      $('.section-maintenance').hide();
      $('.section-return').show();
    })
    .catch(function (error) {
      console.error('API Error:', error);
      $('.section-return').hide();
      $('.section-maintenance').show();
    });

  /* ----------------------------------------------------------------------
   * Search-by field show/hide + marketplace-specific rules
   * -------------------------------------------------------------------- */
  var marketplaceSelect = $('#marketplaces');
  var searchType = $('#search_type');
  var searchForm = $('#searchForm');
  var messageContainer = $('#message-container');

  function resetResults() {
    $('#withdrawal-message').hide().html('').removeClass('withdrawal-not-eu');
    $('#cancelResponseCard').hide();
    $('#cancelItemsBody').html('');
  }

  marketplaceSelect.change(function () {
    searchType.trigger('change');
    resetResults();

    $('.order-msg, .phone-msg, .postalcode-msg, .name-msg, .email-msg')
      .removeClass('invalid-msg').html('');
    $('.orderId, .phone_number, .postalcode, .customer-name, .email').removeClass('invalid-input');

    var selectedOption = $(this).find('option:selected');
    var selectedValue = $(this).val();
    var manageReturnBy = selectedOption.data('manage-return-by');
    var returnInstructions = selectedOption.data('customer-return-instructions');

    if (selectedValue === '5' || selectedValue === '7' || selectedValue === '11') {
      // DEBENHAMS / Secret Sales / ASOS -> mobile only
      searchType.find('option[value="email"]').prop('disabled', true).addClass('hideoption');
      searchType.find('option[value="postalcode"]').prop('disabled', true).addClass('hideoption');
      searchType.find('option[value="name"]').prop('disabled', true).addClass('hideoption');
      searchType.find('option[value="phone"]').prop('disabled', false).removeClass('hideoption');
      searchType.val('phone').trigger('change');
    } else if (selectedValue === '24' || selectedValue === '27') {
      // postal code only
      searchType.find('option[value="email"]').prop('disabled', true).addClass('hideoption');
      searchType.find('option[value="phone"]').prop('disabled', true).addClass('hideoption');
      searchType.find('option[value="name"]').prop('disabled', true).addClass('hideoption');
      searchType.find('option[value="postalcode"]').prop('disabled', false).removeClass('hideoption');
      searchType.val('postalcode').trigger('change');
    } else {
      searchType.find('option').prop('disabled', false).removeClass('hideoption');
      searchType.val('phone').trigger('change');
    }

    if (manageReturnBy === 'partner' && returnInstructions) {
      messageContainer.html(returnInstructions).show();
      searchForm.hide();
    } else {
      messageContainer.html('').hide();
      searchForm.show();
    }
  });

  searchType.change(function () {
    selectOption = this.value;
    $('.email_div, .phone_div, .postalcode_div, .name_div').hide();
    if (this.value === 'phone') {
      $('.phone_div').show();
    } else if (this.value === 'email') {
      $('.email_div').show();
    } else if (this.value === 'name') {
      $('.name_div').show();
    } else {
      $('.postalcode_div').show();
    }
  });

  // Phone number: only last 4 digits
  $('.phone_number').on('input', function () {
    var phoneNumber = $(this).val();
    if (phoneNumber.length > 4) {
      $(this).addClass('invalid-input');
      $('.phone-msg').addClass('invalid-msg').html('Please enter the last 4 digits of your phone number.');
      $('#search-btn').prop('disabled', true);
    } else {
      $(this).removeClass('invalid-input');
      $('.phone-msg').removeClass('invalid-msg').html('');
      $('#search-btn').prop('disabled', false);
    }
  });

  // Trim spaces / dots from Order ID
  (function () {
    var inputField = document.querySelector('.orderId');
    if (inputField) {
      inputField.addEventListener('blur', function () {
        this.value = this.value.replace(/\s+/g, '').replace(/\./g, '');
      });
    }
  })();

  /* ----------------------------------------------------------------------
   * Search submit
   * -------------------------------------------------------------------- */
  $('#search-btn').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    fetchData();
  });

  function validateSearchInputs(values) {
    var ok = true;
    $('.email-msg, .phone-msg, .postalcode-msg, .name-msg, .order-msg').removeClass('invalid-msg').text('');

    if (selectOption === 'phone') {
      if (values.phone === '') {
        $('.phone-msg').addClass('invalid-msg').text('Phone is required');
        $('.phone_number').addClass('invalid-input'); ok = false;
      } else if (values.phone.match(/^[0-9]{4,11}$/) == null) {
        $('.phone-msg').addClass('invalid-msg').text('Invalid Phone Number');
        $('.phone_number').addClass('invalid-input'); ok = false;
      } else {
        $('.phone_number').removeClass('invalid-input');
      }
    } else if (selectOption === 'email') {
      if (values.email === '') {
        $('.email-msg').addClass('invalid-msg').text('Email is required');
        $('.email').addClass('invalid-input'); ok = false;
      } else if (values.email.match(/\S+@\S+\.\S+/) == null) {
        $('.email-msg').addClass('invalid-msg').text('Invalid Email');
        $('.email').addClass('invalid-input'); ok = false;
      } else {
        $('.email').removeClass('invalid-input');
      }
    } else if (selectOption === 'name') {
      if (values.name === '') {
        $('.name-msg').addClass('invalid-msg').text('Name is required');
        $('.customer-name').addClass('invalid-input'); ok = false;
      } else {
        $('.customer-name').removeClass('invalid-input');
      }
    } else {
      if (values.postalcode === '') {
        $('.postalcode-msg').addClass('invalid-msg').text('Postal code is required');
        $('.postalcode').addClass('invalid-input'); ok = false;
      } else if (values.postalcode.match(/^[A-Za-z0-9\s-]{3,10}$/) == null) {
        $('.postalcode-msg').addClass('invalid-msg').text('Invalid Postal Code (3-10 letters, numbers, spaces, or hyphens)');
        $('.postalcode').addClass('invalid-input'); ok = false;
      } else {
        $('.postalcode').removeClass('invalid-input');
      }
    }

    if (values.orderId === '') {
      $('.order-msg').addClass('invalid-msg').text('Order Id is required');
      $('.orderId').addClass('invalid-input'); ok = false;
    } else {
      $('.orderId').removeClass('invalid-input');
    }
    return ok;
  }

  function currentSearchValue(values) {
    if (selectOption === 'phone') return { type: 'phone_number', value: values.phone };
    if (selectOption === 'email') return { type: 'email', value: values.email };
    if (selectOption === 'name') return { type: 'name', value: values.name };
    return { type: 'postal_code', value: values.postalcode };
  }

  function fetchData() {
    var values = {
      email: $('.email').val(),
      phone: $('.phone_number').val(),
      postalcode: $('.postalcode').val(),
      name: $('.customer-name').val(),
      orderId: $('.orderId').val()
    };

    resetResults();
    if (!validateSearchInputs(values)) return;

    var search = currentSearchValue(values);

    $('.spinner-border').show();
    $('.search').prop('disabled', true);
    $('.loader').show();
    $('body').addClass('return-loader-active');

    $.ajax({
      type: 'POST',
      url: baseEndpointUrl + '/v1/api/web/withdrawal/order-items',
      data: {
        marketplace_id: MARKETPLACE_ID,
        order_id: values.orderId,
        search_type: search.type,
        search_value: search.value,
        type: 'return'
      },
      success: function (data) {
        allData = data;
        $('.loader').hide();
        $('body').removeClass('return-loader-active');
        $('.spinner-border').hide();
        $('.search').prop('disabled', false);

        if (data.error) {
          toastrWarn(data.message || 'We could not find your order. Please check your details and try again.');
          return;
        }
        processResult(data, values);
      },
      error: function () {
        $('.loader').hide();
        $('body').removeClass('return-loader-active');
        $('.spinner-border').hide();
        $('.search').prop('disabled', false);
        toastrWarn('An unexpected error occurred. Please try again.');
      }
    });
  }

  /* ----------------------------------------------------------------------
   * Result handling: EU gate -> cancel (unfulfilled) / return (fulfilled)
   * -------------------------------------------------------------------- */
  function isEuOrder(data) {
    if (typeof data.is_eu_order !== 'undefined') return !!data.is_eu_order;
    // Interim fallback until backend returns is_eu_order
    var code = (data.shipping_country_code || '').toUpperCase();
    return EU_COUNTRIES.indexOf(code) !== -1;
  }

  function showWithdrawalMessage(html, isNotEu) {
    var $m = $('#withdrawal-message').removeClass('withdrawal-not-eu');
    if (isNotEu) $m.addClass('withdrawal-not-eu');
    $m.html(html).show();
  }

  // Render priority is intentional — see the backend contract:
  //   1. not an EU order      -> not eligible (stop)
  //   2. already cancelled    -> "already cancelled" (no cancel, no return)
  //   3. has cancellable items -> show cancellation UI
  //   4. fulfilled/dispatched -> "Proceed to Return"
  //   5. otherwise            -> fallback "nothing to cancel"
  function processResult(data, values) {
    resetResults();

    // 1. Not an EU order
    if (!isEuOrder(data)) {
      showWithdrawalMessage(
        '<p>This order is not eligible for the EU Right of Withdrawal.</p>' +
        '<p>If you would like to return or exchange an item, please use our <a href="' + RETURNS_PAGE_URL + '">returns page</a>.</p>',
        true
      );
      return;
    }

    // 2. Already cancelled
    if (data.is_cancelled === true) {
      showWithdrawalMessage('<p>This order has already been cancelled.</p>');
      return;
    }

    // 3. Has items that can be cancelled
    var cancelable = Array.isArray(data.cancelable) ? data.cancelable : [];
    var hasCancellable = cancelable.some(function (it) {
      return String(it.can_cancel) === '1' || it.can_cancel === true;
    });
    if (hasCancellable) {
      renderCancellation(data);
      return;
    }

    // 4. Already dispatched / fulfilled
    if (data.is_fulfilled === true) {
      renderFulfilledMessage(data, values);
      return;
    }

    // 5. Fallback
    showWithdrawalMessage('<p>There are no items on this order that are available to cancel.</p>');
  }

  function renderFulfilledMessage(data, values) {
    // The returns page supports search by phone / email / postal code (NOT name).
    // The withdrawal response always returns the customer's email + phone + order_name,
    // so we deep-link using email (preferred) or phone — regardless of how the customer
    // searched here (so a name search still works). The marketplace partner/dropdown is
    // intentionally NOT passed — the returns page auto-detects it from the order. Phone
    // search uses the last 4 digits only.
    // Order reference: prefer the marketplace order number (marketplace_id = mp_order_no)
    // when present, otherwise the order name.
    var orderRef = data.marketplace_id || data.order_name || data.order_no || values.orderId;
    var url;

    if (data.email) {
      url = RETURNS_PAGE_URL +
        '?search_type=email' +
        '&search_value=' + encodeURIComponent(data.email) +
        '&order_id=' + encodeURIComponent(orderRef) +
        '&type=return';
    } else if (data.phone) {
      var last4 = String(data.phone).replace(/\D/g, '').slice(-4);
      url = RETURNS_PAGE_URL +
        '?search_type=phone' +
        '&search_value=' + encodeURIComponent(last4) +
        '&order_id=' + encodeURIComponent(orderRef) +
        '&type=return';
    } else {
      // Last-resort fallback if no contact details are returned.
      var customerId = (typeof data.buyer_lead_id !== 'undefined') ? data.buyer_lead_id : data.customer;
      var orderNo = (typeof data.order_no !== 'undefined') ? data.order_no : values.orderId;
      url = RETURNS_PAGE_URL +
        '?customer_id=' + encodeURIComponent(customerId) +
        '&order_id=' + encodeURIComponent(orderNo) +
        '&type=return';
    }

    $('#withdrawal-message')
      .html(
        '<p>This order has already been dispatched, so it can no longer be cancelled.</p>' +
        '<p>You can still return it &mdash; we accept returns within 35 days. ' +
        'Click below to start a return for this order.</p>' +
        '<div class="withdrawal-action"><a class="btn-proceed-return" href="' + url + '" target="_blank" rel="noopener">Proceed to Return</a></div>'
      )
      .show();
  }

  /* ----------------------------------------------------------------------
   * Cancellation UI (reason optional)
   * -------------------------------------------------------------------- */
  function renderCancellation(data) {
    var items = data.cancelable || [];
    var reasons = data.cancel_reasons || data.reasons || [];

    var reasonOptions = '<option value="">Select a reason (optional)</option>';
    reasons.forEach(function (r) {
      reasonOptions += '<option value="' + r.id + '" data-reason-name="' + escapeHtml(r.name) + '">' + escapeHtml(r.name) + '</option>';
    });

    var html = '';
    html += '<h4 class="p-3 returnheading text-center">Cancel Order Items</h4>';
    html += '<p class="cancel-intro text-center">Select the item(s) you wish to cancel. Providing a reason is optional.</p>';

    var anyCancelable = false;

    items.forEach(function (item) {
      var canCancel = String(item.can_cancel) === '1' || item.can_cancel === true;
      if (canCancel) anyCancelable = true;

      html += '<div class="cancel-row" id="cancel-card-' + item.id + '" data-line-item-id="' + item.id + '">';

      // checkbox
      html += '<div class="cancel-col-check">';
      if (canCancel) {
        html += '<input class="form-check-input cancelcheckbox" type="checkbox" data-line-item-id="' + item.id + '" value="' + item.id + '">';
      }
      html += '</div>';

      // image
      html += '<div class="cancel-col-img"><img class="cancel-item-img" src="' +
        (item.image || '') + '" alt="' + escapeHtml(item.name || '') + '"></div>';

      // details
      html += '<div class="cancel-col-detail">';
      html += '<div class="card-title">' + escapeHtml(item.name || '') +
        (item.color ? ' - ' + escapeHtml(item.color) : '') + (item.size ? '-' + escapeHtml(item.size) : '') + '</div>';
      html += '<div>SKU: ' + escapeHtml(item.sku || item.code || '') + '</div>';
      html += '<div><b>Qty:</b> ' + (item.quantity || '') + '</div>';
      if (typeof item.price !== 'undefined') html += '<div><b>Price:</b> £' + item.price + '</div>';
      if (item.brand) html += '<div>Brand: ' + escapeHtml(item.brand) + '</div>';
      if (item.cancel_qty && Number(item.cancel_qty) > 0) {
        html += '<div class="canceled-qty">Cancelled quantity: ' + item.cancel_qty + '</div>';
      }
      html += '</div>';

      // controls (qty + reason) OR status message
      html += '<div class="cancel-col-controls">';
      if (canCancel) {
        var maxQty = item.available_qty || item.availableQty || item.quantity || 1;
        html += '<div class="cancel-qty-wrap">';
        html += '<label>Quantity</label>';
        html += '<div class="input-container">';
        html += '<button type="button" class="minus-btn cancel-minus"> </button>';
        html += '<input type="number" class="form-control quantity cancel-qty-input" min="1" max="' + maxQty +
          '" data-max-qty="' + maxQty + '" data-line-item-id="' + item.id + '" value="1">';
        html += '<button type="button" class="plus-btn cancel-plus"> </button>';
        html += '</div>';
        html += '</div>';

        html += '<div class="cancel-reason-wrap">';
        html += '<label>Reason</label>';
        html += '<select class="cancel-reason-select" data-line-item-id="' + item.id + '">' + reasonOptions + '</select>';
        html += '<div class="cancel-other-reason-box" style="display:none;">';
        html += '<label>Please specify</label>';
        html += '<textarea class="cancel-other-reason-textarea" maxlength="120" data-line-item-id="' + item.id + '"></textarea>';
        html += '</div>';
        html += '<div class="cancelerrormsg cancel-error-' + item.id + '"></div>';
        html += '</div>';
      } else {
        html += '<div class="cancel-status-wrap">' + cancelStatusMessage(item) + '</div>';
      }
      html += '</div>'; // cancel-col-controls

      html += '</div>'; // cancel-row
    });

    if (anyCancelable) {
      html += buildWithdrawalDeclaration(data);
    }

    html += '<div class="cancelerror text-danger text-center"></div>';
    html += '<div class="cancel-success"></div>';
    html += '<div class="cancel-submit-wrapper text-end">';
    if (anyCancelable) {
      html += '<button type="button" class="btn primary-color submitcancelbtn" ' +
        'data-order="' + data.order + '" data-customer="' + data.customer + '">Cancel Selected Items</button>';
    }
    html += '</div>';

    $('#cancelItemsBody').html(html);
    $('#cancelResponseCard').show();
  }

  function cancelStatusMessage(item) {
    var status = (item.cancel_status || '').toLowerCase();
    if (status === 'pending') {
      return '<p class="cancel-status-msg" style="color:#dc3545;">Your cancellation request has been received and is currently being processed by our team.</p>';
    }
    if (status === 'accepted') {
      return '<p class="cancel-status-msg" style="color:#198754;">Your cancellation has been processed and a refund issued to your original payment method.</p>';
    }
    if (status === 'declined') {
      return '<p class="cancel-status-msg" style="color:#dc3545;">Your cancellation request has been declined.</p>';
    }
    return '<p class="cancel-status-msg" style="color:#dc3545;">This item is not eligible for cancellation.</p>';
  }

  // Model withdrawal declaration (shown when order details load) — captures the
  // statement, order/product details, name, address, dates and the equivalent
  // confirmation, per the EU Right of Withdrawal requirements.
  function buildWithdrawalDeclaration(data) {
    var orderNo = escapeHtml(data.order_name || data.order_no || '');
    var name = data.customer_name ? escapeHtml(data.customer_name) : '—';
    var address = data.customer_address ? escapeHtml(data.customer_address).replace(/\n/g, '<br>') : '—';
    var today = formatToday();

    var html = '';
    html += '<div class="withdrawal-declaration">';
    html += '<h5 class="withdrawal-declaration-title">Withdrawal declaration</h5>';
    html += '<p>I hereby give notice that I withdraw from my contract of sale of the item(s) I have selected above.</p>';
    html += '<ul class="withdrawal-declaration-list">';
    html += '<li><span class="wd-label">Order:</span><span class="wd-value">' + orderNo + '</span></li>';
    html += '<li><span class="wd-label">Date goods received:</span><span class="wd-value">Not yet received — order not dispatched</span></li>';
    html += '<li><span class="wd-label">Name:</span><span class="wd-value">' + name + '</span></li>';
    html += '<li><span class="wd-label">Address:</span><span class="wd-value">' + address + '</span></li>';
    html += '<li><span class="wd-label">Date of this declaration:</span><span class="wd-value">' + escapeHtml(today) + '</span></li>';
    html += '</ul>';
    html += '<p class="withdrawal-declaration-note">By clicking &ldquo;Cancel Selected Items&rdquo;, you confirm this withdrawal declaration. A confirmation will be emailed to you.</p>';
    html += '</div>';
    return html;
  }

  function formatToday() {
    var d = new Date();
    try {
      return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' });
    } catch (e) {
      return d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear();
    }
  }

  /* ----- Cancellation interactions (delegated) ----- */
  function checkRow(id) {
    $('#cancel-card-' + id).addClass('selected-row').find('.cancelcheckbox').prop('checked', true);
    $('.cancelerror').text('');
  }

  $(document).on('click', '#cancelItemsBody .cancel-plus, #cancelItemsBody .cancel-minus', function () {
    var input = $(this).closest('.input-container').find('.cancel-qty-input');
    var val = parseInt(input.val(), 10) || 1;
    var max = parseInt(input.attr('data-max-qty'), 10) || 1;
    if ($(this).hasClass('cancel-plus') && val < max) val++;
    if ($(this).hasClass('cancel-minus') && val > 1) val--;
    input.val(val);
    checkRow(input.data('lineItemId'));
  });

  $(document).on('change', '#cancelItemsBody .cancel-qty-input', function () {
    var max = parseInt($(this).attr('data-max-qty'), 10) || 1;
    var val = parseInt($(this).val(), 10) || 1;
    if (val < 1) val = 1;
    if (val > max) val = max;
    $(this).val(val);
    checkRow($(this).data('lineItemId'));
  });

  $(document).on('change', '#cancelItemsBody .cancelcheckbox', function () {
    var row = $(this).closest('.cancel-row');
    var id = $(this).data('lineItemId');
    if (this.checked) {
      row.addClass('selected-row');
      $('.cancelerror').text('');
    } else {
      row.removeClass('selected-row');
      row.find('.cancel-qty-input').val(1);
      row.find('.cancel-reason-select').val('');
      row.find('.cancel-other-reason-box').hide();
      row.find('.cancel-other-reason-textarea').val('');
      $('.cancel-error-' + id).text('');
    }
  });

  $(document).on('change', '#cancelItemsBody .cancel-reason-select', function () {
    var id = $(this).data('lineItemId');
    var selected = $(this).find('option:selected');
    var name = (selected.data('reason-name') || selected.text() || '').toLowerCase();
    var otherBox = $(this).closest('.cancel-reason-select').siblings('.cancel-other-reason-box');
    if (name === 'other') {
      otherBox.show();
    } else {
      otherBox.hide().find('.cancel-other-reason-textarea').val('');
    }
    if ($(this).val() !== '') checkRow(id); // selecting a reason implies intent to cancel
  });

  $(document).on('click', '#cancelItemsBody .submitcancelbtn', function () {
    var $btn = $(this);
    var orderId = $btn.data('order');
    var customerId = $btn.data('customer');

    $('.cancelerror').text('');
    $('.cancelerrormsg').text('');

    var items = [];
    var valid = true;
    var checkedCount = $('#cancelItemsBody .cancelcheckbox:checked').length;

    if (checkedCount === 0) {
      $('.cancelerror').text('Please select at least one item to cancel.');
      return;
    }

    $('#cancelItemsBody .cancelcheckbox:checked').each(function () {
      var id = $(this).val();
      var row = $('#cancel-card-' + id);
      var quantity = row.find('.cancel-qty-input').val();
      var $reason = row.find('.cancel-reason-select');
      var reasonId = $reason.val();
      var reasonName = ($reason.find('option:selected').data('reason-name') || '').toLowerCase();
      var isOther = reasonName === 'other';
      var otherReason = row.find('.cancel-other-reason-textarea').val();
      var product = row.find('.card-title').text();

      // Reason is OPTIONAL — only enforce the free-text box if "Other" is chosen.
      if (isOther && (!otherReason || otherReason.trim() === '')) {
        valid = false;
        $('.cancel-error-' + id).text('Please specify the reason in the text box.');
        return;
      }

      items.push({
        id: id,
        product: product,
        quantity: quantity,
        reason_id: reasonId || null,
        other_reason: isOther ? otherReason : null
      });
    });

    if (!valid) return; // per-item errors are already shown
    if (items.length === 0) return; // safety net

    $btn.prop('disabled', true).append('<span class="loaderbtn"> </span>');

    $.ajax({
      type: 'POST',
      url: baseEndpointUrl + '/v1/api/web/withdrawal/cancel',
      contentType: 'application/json',
      data: JSON.stringify({ order_id: orderId, customer_id: customerId, items: items }),
      success: function (response) {
        $btn.find('.loaderbtn').remove();
        $btn.prop('disabled', false);
        if (response && response.code === 200) {
          var msg = response.message || 'Your withdrawal request has been submitted successfully.';
          // Replace the whole cancellation view with the success message only.
          // Do NOT auto re-run the search (that re-fetch was briefly showing the
          // "already cancelled" state right after success).
          $('#cancelItemsBody').html('<div class="cancel-success"><p>' + escapeHtml(msg) + '</p></div>');
          var card = document.getElementById('cancelResponseCard');
          if (card) {
            window.scrollTo({ top: card.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
          }
        } else {
          toastrWarn((response && response.message) || 'Failed to cancel the order. Please try again.');
        }
      },
      error: function (xhr) {
        $btn.find('.loaderbtn').remove();
        $btn.prop('disabled', false);
        // 429 = concurrent double-submit guard; surface the server message when present.
        var msg = (xhr && xhr.responseJSON && xhr.responseJSON.message)
          ? xhr.responseJSON.message
          : 'Failed to cancel the order. Please try again.';
        toastrWarn(msg);
      }
    });
  });

  /* ----------------------------------------------------------------------
   * Helpers
   * -------------------------------------------------------------------- */
  function toastrWarn(msg) {
    if (window.toastr && typeof window.toastr.warning === 'function') {
      window.toastr.warning(msg);
    } else {
      alert(msg);
    }
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
})();
